import administrationRoutes from '@/routes/administration.routes';
import clientProfileRoutes from '@/routes/clientProfile.routes';
import messagingRoutes from '@/routes/messaging.routes';
import reportsRoutes from '@/routes/reports.routes';
import accountingRoutes from './accounting.routes';
import coordinationRoutes from './coordination.routes';
import cosmetologyRoutes from './cosmetology.routes';
import customerServiceQARoutes from './customerServiceQA.routes';
import frontDeskRoutes from './frontdesk.routes';
import humanResourcesRoutes from './humanResources.routes';
import identityRoutes from './identity.routes';
import inventoryRoutes from './inventory.routes';
import medicalServicesRoutes from './medical.routes';
import planningTasksRoutes from './planningTasks.routes';
import profileRoutes from './profile.routes';
import publicityRoutes from './publicity.routes';
import salesRoutes from './sales.routes';
import settingsRoutes from './settings.routes';

const routes = [
    ...administrationRoutes,
    ...clientProfileRoutes,
    ...identityRoutes,
    ...humanResourcesRoutes,
    ...profileRoutes,
    ...settingsRoutes,
    ...publicityRoutes,
    ...salesRoutes,
    ...inventoryRoutes,
    ...frontDeskRoutes,
    ...accountingRoutes,
    ...coordinationRoutes,
    ...medicalServicesRoutes,
    ...customerServiceQARoutes,
    ...planningTasksRoutes,
    ...cosmetologyRoutes,
    ...reportsRoutes,
    ...messagingRoutes,
];

export default routes;
